var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44384 4.4353C7.76477 1.11906 13.1632 1.15433 16.5044 4.49556C19.8471 7.83822 19.881 13.2399 16.5604 16.5604C13.2398 19.881 7.83819 19.8471 4.49552 16.5044C2.51465 14.5236 1.69666 11.8212 2.04791 9.25855C2.09713 8.89945 2.42812 8.6483 2.7872 8.69752C3.14628 8.74674 3.39747 9.07769 3.34826 9.43679C3.05077 11.607 3.74309 13.8959 5.4236 15.5764C8.26252 18.4153 12.8331 18.4315 15.6323 15.6323C18.4315 12.8331 18.4153 8.26256 15.5763 5.42364C12.7389 2.58616 8.17153 2.56847 5.37193 5.36337L6.02617 5.36666C6.3886 5.36848 6.68093 5.66377 6.67911 6.0262C6.67729 6.38864 6.382 6.68097 6.01957 6.67915L3.79221 6.66796C3.43235 6.66614 3.14108 6.37487 3.13927 6.01501L3.12808 3.78765C3.12625 3.42522 3.41859 3.12994 3.78102 3.12811C4.14346 3.12629 4.43874 3.41863 4.44056 3.78106L4.44384 4.4353Z",
    fill: "#4A4A53",
    stroke: "#4A4A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5 6.34375C10.8624 6.34375 11.1563 6.63757 11.1563 7V10.2281L13.1515 12.2235C13.4078 12.4798 13.4078 12.8952 13.1515 13.1515C12.8952 13.4078 12.4798 13.4078 12.2235 13.1515L10.1 11.0282C9.93598 10.864 9.84375 10.6415 9.84375 10.4094V7C9.84375 6.63757 10.1376 6.34375 10.5 6.34375Z",
    fill: "#4A4A53",
    stroke: "#4A4A53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.02243386369ec35729bc9d04ac24e2e6.svg";
export { ForwardRef as ReactComponent };